import { useParams } from 'react-router-dom';
import useProposalData from '../hooks/useProposalData';
import ProposalAgreement from '../components/ProposalAgreement';
import LoadingScreen from '../components/LoadingScreen';

export default function ProposalPage() {
  const { dealId } = useParams();
  const { data, loading, error } = useProposalData(dealId);

  if (loading) return <LoadingScreen />;

  if (error) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0F0F1E', color: '#fff', fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif" }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>😕</div>
          <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 8 }}>Proposal Not Found</h1>
          <p style={{ color: '#94A3B8', fontSize: 16 }}>{error}</p>
        </div>
      </div>
    );
  }

  return <ProposalAgreement proposalData={data} />;
}
